import * as React from "react";
import { useTheme as useAppTheme } from "../../context/ThemeContext";
import { Button, Dialog, OutlinedInput, Typography, Stack } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import ApiService from "../../services/api-service";
import Loader from "../../components/Loader";
import notifier from "../../components/Notifier";
import { getErrorString } from "../../constants/function";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function BidPopup(props) {
  const { t } = useTranslation("common");
  const { getCurrentBranding } = useAppTheme();
  const brandName = getCurrentBranding()?.appName || "SIKI";
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState("");
  const [currency, setCurrency] = React.useState("siki");
  const [value, setValue] = React.useState(0);
  const [charge, setCharge] = React.useState({});

  // Handles placing a bid
  const bid = async () => {
    if (amount < props.highestBid) {
      notifier.info("Bid amount cannot be less than the highest bid");
    } else {
      try {
        const payload = {
          auctionId: props.auctionId,
          nftId: props.nftId,
          amount: amount,
          currency: currency,
          type: props.type,
        };
        setLoading(true);
        const response = await ApiService.BID_NFT_V2(payload);
        setLoading(false);
        dispatch(getBalance());
        notifier.success(response.result);
        props.handleClose({ amount: amount });
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    }
  };

  // Handles purchasing the NFT immediately
  const buyNow = async () => {
    try {
      const payload = {
        nftId: props.fractionId,
        _id: props.saleId,
        currency: "siki",
        type: props.type,
      };

      console.log("BidPopup props:", props);
console.log("Payload being sent to BUY_NFT_V2:", {
  nftId: props.fractionId,
  _Id: props.saleId,
    currency: "siki",
  type: props["type"],
});
      setLoading(true);
      const response = await ApiService.BUY_NFT_V2(payload);
      setLoading(false);
      dispatch(getBalance());
      notifier.success(response.result);
      props.handleClose({ amount: amount });
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  // Updates currency and calculates value
  const handleChange = (event) => {
    setCurrency(event.target.value);
    calculate(event.target.value);
  };

  React.useEffect(() => {
    if (props.isBuy) {
      setAmount(props.sellingPrice);
      setValue(props.sellingPrice);
    } else {
      setAmount(props.highestBid || 0);
      setValue(props.highestBid || props.sellingPrice);
    }
    getChanges();
  }, [props.sellingPrice, props.highestBid, props.isBuy]);

  // Fetches charge data
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response.result) {
        setCharge({ ...response.result });
      }
    } catch (error) {
      console.error("Failed to retrieve charges:", error);
    }
  };

  // Calculates amount based on currency and value
  const calculate = (currency, val) => {
    const tempAmount = val ? parseInt(val) : parseInt(amount);
    if (currency === "siki" && props.isBuy) {
      setValue(props.sellingPrice);
    } else if (currency === "hbar" && props.isBuy) {
      const buyValue = props.sellingPrice;
      setValue(charge.rate * (1 / charge.hbarValueInUsd) * buyValue);
    } else if (currency === "siki" && !props.isBuy) {
      setValue(tempAmount || props.highestBid);
    } else if (currency === "hbar" && !props.isBuy) {
      const buyValue = tempAmount || props.highestBid;
      setValue(charge.rate * (1 / charge.hbarValueInUsd) * buyValue);
    }
  };

  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(false)}
        PaperProps={{
          style: {
            backgroundColor: "#171515",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            padding: 16,
            position: "relative",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <Typography className="fs-14">
            {props.isBuy ? "" : t("biddingPopup.text8")}
          </Typography>
          {props.isBuy ? (
            <Typography className="fs-14">{`${props.sellingPrice} ${t("biddingPopup.text3")}`}</Typography>
          ) : (
            <DialogContent sx={{ padding: 0 }}>
              <OutlinedInput
                sx={{ height: "50px", width: "100%" }}
                type="number"
                autoFocus
                margin="dense"
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value);
                  calculate(currency, e.target.value);
                }}
                placeholder={t("biddingPopup.text4")}
              />
              <Typography
                sx={{
                  color: "#F48706 !important",
                  padding: "5px 0",
                  fontSize: "12px !important",
                }}
              >
                Last {props.isBuy ? t("biddingPopup.text6") : t("biddingPopup.text7")}{" "}
                {t("biddingPopup.text9")} : {props.highestBid || props.sellingPrice} {brandName} Coins
              </Typography>
            </DialogContent>
          )}
          
          {/* Optionally add currency options if necessary */}
          {/* <Stack>
            <Typography
              sx={{
                color: "#F48706 !important",
                padding: "5px 0",
                fontSize: "12px !important",
              }}
            >
              You will be charged {value.toFixed(4)}{" "}
              {currency === "siki" ? "Siki" : "HBar"} Coins{" "}
              {props.inSaleCount ? " /NFT" : ""}
            </Typography>
            <Typography className="fs-14 " color="default">
              Pay using
            </Typography>
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
              aria-labelledby="currency type"
              name="select token type"
              value={currency}
              onChange={handleChange}
            >
              <FormControlLabel
                value="siki"
                control={<Radio color="primary" />}
                label={<Typography color="default" className="fs-13">SIKI Coins</Typography>}
              />
              <FormControlLabel
                value="hbar"
                control={<Radio color="primary" />}
                label={<Typography color="default" className="fs-13">HBar</Typography>}
              />
            </RadioGroup>
          </Stack> */}

          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Button
              sx={{ maxWidth: "150px", padding: "10px 35px" }}
              color="default"
              onClick={() => props.handleClose(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              sx={{ maxWidth: "150px", padding: "10px 35px" }}
              className="white-space-pre"
              variant="contained"
              color="primary"
              onClick={() => (props.isBuy ? buyNow() : bid())}
              disabled={props.isBuy ? !amount : amount < props.highestBid}
            >
              {props.isBuy ? t("nftDetail.nftRow.button4") : t("nftDetail.nftRow.button3")}
            </Button>
          </DialogActions>
        </Stack>
        {loading && <Loader wait={true} />}
      </Dialog>
    </div>
  );
}
